export const LOGO = "https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png"

export const API_OPTIONS = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIzMDNhMzJjZDM0YWI3YmI5ZmZiZmJkZGVjMWY3YmI5MCIsInN1YiI6IjY2NWNlYjg3NzI2MjFjOWU1YjRlMzUwNSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.6UQCke-2ZUEmzBIoS8x1CZoIYEYmX6KmAvrxfixuScI'
    }
  };
  

  export const IMG_CDN_URL = "https://image.tmdb.org/t/p/w500"
  export const BG_URL = "https://assets.nflxext.com/ffe/siteui/vlv3/dd4dfce3-1a39-4b1a-8e19-b7242da17e68/86742114-c001-4800-a127-c9c89ca7bbe4/IN-en-20240527-popsignuptwoweeks-perspective_alpha_website_large.jpg"


  export const SUPPORTED_LANGUAGES = [
    {identifier : "en" , name : "English"},
    {identifier : "hindi" , name : "Hindi"},
    {identifier : "spanish" , name : "Spanish"}
  ]